import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Footer = styled.div`
    width: 100%;
    position: relative;
    z-index: 3000;
    pointer-events: auto;
`;

export const AccountPaginationContainer = styled.div`
    margin-top: 3px;
    background-color: white;
    box-shadow: 0px -3px 6px #00000014;
    border-radius: 4px 4px 0px 0px;
    opacity: 1; 
    z-index: 2500;

     @media all and (width: 1024px) and (height: 1366px) and (orientation: portrait) {
        bottom: 0 !important;
        padding-top: 14px !important;
        background-color: #f5f5f5 !important;
    }
    @media all and (width: 1366px) and (height: 1024px) and (orientation: landscape) {
        bottom: 0 !important;
        padding-top: 14px !important;
        background-color: #f5f5f5 !important;

    @media screen and (min-width: 1080px) and (max-width: 1090px) and (orientation: landscape) {
        &:last-child { 
        margin-top:5% !important;
        position: sticky !important; 
        width: ${(props) => props.width || '100%'};
        justify-self: ${(props) => props.justifySelf || ''};
        }    }
    }
    @media all and (width: 1024px) and (height: 768px) and (orientation: landscape) {
        margin-bottom: 35px;
        z-index: 3000;
    }
    ${media.mobileDevice`
    display : none;
    flex-direction:column;
    width:100% !important;
    margin: 10px 0px 0px 0px;
    box-shadow: none;
    border-radius: none;   
    position: fixed !important;   
    bottom:0 !important;
    padding-top:14px !important;
    background-color:#F5F5F5 !important;
`}
    @media all and (width: 896px) and (height: 414px) and (orientation: landscape) {
        bottom: 0 !important;
        padding-top: 14px !important;
        background-color: #f5f5f5 !important;
    }
    @media all and (width: 414px) and (height: 896px) and (orientation: portrait) {
        position: fixed !important;
        bottom: 0 !important;
        padding-top: 14px !important;
        background-color: #f5f5f5 !important;
    }

    .custom-footer-wrapper {
        width: calc(100% - 5rem);
    }
`;

export const DesktopView = styled.div`
    display: block;
    @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) {
        position: fixed;
        bottom: 0;
        width: 90% !important;
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        position: fixed;
        bottom: 0;
        width: 100%;
    }
    ${media.mobileDevice`
        display: none;
    `}
`;

export const PaginationContainerMobile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
    width: 100%;
    display: none;
    ${media.mobileDevice`
        display: block;
        flex-direction:column;
        justify-content: space-between;
        padding-bottom: 2px;
        padding-top: 10px;
    `}
`;
export const PaginationContainer = styled.div`
    margin-top: 12px;
    height: 48px;
    background: #f6f6f6 0% 0% no-repeat padding-box;
    box-shadow: none;
    border-radius: 4px 4px 0px 0px;
    opacity: 1;

    ${media.smalDevice`                    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mediumDevice`    
        height: auto;
        box-shadow: none;
        border-radius: none;    
    `}
    ${media.mobileDevice`
    flex-direction:column;
    margin: 10px 0px 0px 0px;
    box-shadow: none;
    border-radius: none;        
`}
`;

export const PaginationContainerWeb = styled.div`
    ${media.mobileDevice`
        display: none;
    `}
`;

export const MobileView = styled.div`
    display: none;
    ${media.mobileDevice`
        display: block;
        background-color:#f5f5f5 !important;
        position: fixed;
        width: 100%;
        bottom: 0;
        z-index: 3001;
    `}
`;
